// useVoices — the device's available speech-synthesis voices, kept fresh.
//
// `speechSynthesis.getVoices()` is frequently empty on first call and only
// populates after the engine fires `voiceschanged`, so we read once and then
// subscribe. Returns an empty array where speech isn't supported (SSR / the
// test runner), so callers never have to guard.

import { useEffect, useState } from 'react';

function speechAvailable(): boolean {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

export function useVoices(): SpeechSynthesisVoice[] {
  const [voices, setVoices] = useState<SpeechSynthesisVoice[]>([]);

  useEffect(() => {
    if (!speechAvailable()) return;
    const read = (): void => setVoices(window.speechSynthesis.getVoices() ?? []);
    read();
    window.speechSynthesis.addEventListener?.('voiceschanged', read);
    return () => window.speechSynthesis.removeEventListener?.('voiceschanged', read);
  }, []);

  return voices;
}
